var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"text-info small"},[_vm._v(" 本日計費："+_vm._s(_vm.data && _vm.data.TerminalCount || 0)+" 個設備，共 "),_c('img',{staticClass:"img-pt",attrs:{"src":"/img/service_point.png"}}),_vm._v(" "+_vm._s(_vm.data && _vm.data.TodayUsage || 0)+" 點 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }